export default "__VITE_ASSET__xtw8xdI$__"